import { ViewModel,View, ObservableArray, ViewModelMessage } from "binder"
import moment = require("moment");
import { ShowPopupMessage } from "src/binder/uiPatterns/mvvm/viewmodel";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { TransactionDetailViewModel } from "../transactionList/transactionDetail/transactionDetail-viewModel";
import { BalanceSheetView } from "./balanceSheet-view"
import { translate } from "src/common/utilities";

export class BalanceSheetViewModel extends WindowViewModel{
    public getTitle(): string {
        return translate("balanceSheet-viewModel.accountTrackingAndBrowsing",{});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.filters = ObservableArray.create<singleFilter>();
        this.loaders = ObservableArray.create<BalanceLoaderInfoProvider>();
        this.balances = ObservableArray.create<singleBalance>();
        this.loaders.push(...[
            new AccountFirstLevel(this),
            new AccountSecondLevel(this),
            new AccountThirdLevel(this),
            new AccountCustomLevel(this),
            new DistinguishingDetailLevel(this),
            new DistinguishingDetailValueLevel(this)
        ]);
        this.show(this.loaders[0]);
        this.popupStack2 =[];
    }
    GetDefaultView(): View <ViewModel> {
        return new BalanceSheetView();
    }
    public getTypeId(): string {
        return "VM-B2F8B07C-7285-4153-BE15-7E95CF2BEA84"
    }

    public set filters(v: ObservableArray<singleFilter>) { this._filters = v; } public get filters(): ObservableArray<singleFilter> { return this._filters;} private _filters: ObservableArray<singleFilter>;
    public set balances(v: ObservableArray<singleBalance>) { this._balances = v; } public get balances(): ObservableArray<singleBalance> { return this._balances;} private _balances: ObservableArray<singleBalance>;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loaders(v: ObservableArray<BalanceLoaderInfoProvider>) { this._loaders = v; } public get loaders(): ObservableArray<BalanceLoaderInfoProvider> { return this._loaders;} private _loaders: ObservableArray<BalanceLoaderInfoProvider>;

    private popupStack2:IPopup[];
    public loaderInfoProvider:BalanceLoaderInfoProvider;
    


    async refresh(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/AccountingServices/GetBalanceSheet',{
                Type:this.loaderInfoProvider.type,
                Depth:this.loaderInfoProvider.depth,
                From:this.from,
                Until:this.until,
                Participants:this.filters.map(x=>{ 
                    return {
                        Participants:x.filters.map(q=>q.id)
                    };
                })
            });
            this.balances.update(...result.FoundParticipants.map((x,i)=>{
                let r = new singleBalance(this);
                r.index = i+1;
                r.isSelected = false;
                r.participantCode = x.Code;
                r.participantId = x.Id;
                r.participantName = x.Name;
                r.startCredit = x.StartCredit;
                r.startDebt = x.StartDebt;
                r.totalCredit = x.TotalCredit;
                r.totalDebt = x.TotalDebt;
                r.diffCredit = x.DifferenceCredit;
                r.diffDebt = x.DifferenceDebt;
                r.finalCredit = x.FinalCredit;
                r.finalDebt = x.FinalDebt;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    removeFilter(filter:singleFilter){
        this.filters.remove(filter);
    }
    private selectLoader(loader: BalanceLoaderInfoProvider) {
        this.loaders.forEach(x=>x.isSelected=false);
        loader.isSelected = true;
        this.loaderInfoProvider = loader;

    }
    show(loader: BalanceLoaderInfoProvider){
        this.selectLoader(loader);
        this.refresh();
    }

    getCurrentLoader():BalanceLoaderInfoProvider{
        return this.loaders.filter(x=>x.isSelected)[0];
    }

    showFiltered(loader: BalanceLoaderInfoProvider){
        let currentLoader = this.getCurrentLoader();
        this.selectLoader(loader);
        let filter = new singleFilter(this);
        filter.name = currentLoader.getName();
        let filterItems = this.balances.filter(x=>x.isSelected).map(x=>{
            let f = new singleFilterItem(filter);
            f.id = x.participantId;
            f.name = x.participantName;
            f.code = x.participantCode;
            return f;
        });
        if(filterItems.length>0){
            filter.filters.update(...filterItems);
            this.filters.push(filter);
        }
        this.refresh();
    }

    DeleteFilter(singlefilter){
        this.filters.remove(singlefilter)
    }

    public async handleMessage(message: ViewModelMessage) {
        if(message instanceof ShowPopupMessage){
            this.popupStack2.push(message.popup);
            if(this.popupStack2.length>1)
                message.autoHide = false;
            await super.handleMessage(message);
            this.popupStack2.pop();
            if(this.popupStack2.length>0){
                let previousPopup = this.popupStack2.pop();
                this.requestShowingPopup(previousPopup);
            }
        }else{
            return super.handleMessage(message);
        }
    }
    
    async getRelatedTransactions()
    {
        try
        {
            this.isLoading = true;
            
            let currentFilters = this.filters.map(x=>{ 
                return {
                    Participants:x.filters.map(q=>q.id)
                };
            });
            let newSelections = this.balances.filter(x=>x.isSelected).map(x=>x.participantId);
            let resultFilter = currentFilters;
            if(newSelections.length>0)
                resultFilter.push({
                    Participants:newSelections
                });
            
            let entriesViewModel = new TurnOverViewModel(this)
            entriesViewModel.updateShowingTransactions(this.from,this.until,resultFilter);
            this.requestShowingPopup(entriesViewModel);
        }
        catch (ex) 
        {
            console.log(ex);
        } 
        finally 
        {
            this.isLoading = false;
        }
    }

}

export abstract class BalanceLoaderInfoProvider extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:BalanceSheetViewModel) {
        super(parent);
        this.balanceSheetViewModel = parent;
        
    }
    private balanceSheetViewModel : BalanceSheetViewModel;
    public set type(v: number) { this._type = v; } public get type(): number { return this._type;} private _type: number;
    public set depth(v: number) { this._depth = getAsNumber(v); } public get depth(): number { return this._depth;} private _depth: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;

    show(){
        this.balanceSheetViewModel.show(this);
    }
    showFiltered(){
        this.balanceSheetViewModel.showFiltered(this);
    }
    getName(){
        return this.name;
    }
}
abstract class AccountLevel extends BalanceLoaderInfoProvider{
    constructor(parent:BalanceSheetViewModel) {
        super(parent);
        this.type = 1;
    }
} 

class AccountFirstLevel extends AccountLevel{
    constructor(parent:BalanceSheetViewModel) {
        super(parent);
        this.depth = 1;
        this.name = translate("balanceSheet-viewModel.total",{});
        
    }
} 
class AccountSecondLevel extends AccountLevel{
    constructor(parent:BalanceSheetViewModel) {
        super(parent);
        this.depth = 2;
        this.name = translate("balanceSheet-viewModel.subsidiaryAccount",{});
    }
} 
class AccountThirdLevel extends AccountLevel{
    constructor(parent:BalanceSheetViewModel) {
        super(parent);
        this.depth=3;
        this.name = translate("balanceSheet-viewModel.distinguish",{});
    }
} 
class AccountCustomLevel extends AccountLevel{
    public getTypeId(): string {return 'accountcustomlevel';}

    constructor(parent:BalanceSheetViewModel) {
        super(parent);
        this.name = translate("balanceSheet-viewModel.selectiveLevel",{});
    }

    getName(){
        return translate("balanceSheet-viewModel.depth",{depth:this.depth});
    }
}
class DistinguishingDetailLevel extends BalanceLoaderInfoProvider{
    constructor(parent:BalanceSheetViewModel) {
        super(parent);
        this.type=2;
        this.depth=1;
        this.name = translate("balanceSheet-viewModel.distinguishCenters",{});

    }
} 
class DistinguishingDetailValueLevel extends BalanceLoaderInfoProvider{
    constructor(parent:BalanceSheetViewModel) {
        super(parent);
        this.type=4;
        this.depth=1;
        this.name = translate("balanceSheet-viewModel.distinguishValues",{});
    }
} 

export class singleBalance extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set participantId(v: string) { this._participantId = v; } public get participantId(): string { return this._participantId;} private _participantId: string;
    public set participantName(v: string) { this._participantName = v; } public get participantName(): string { return this._participantName;} private _participantName: string;
    public set participantCode(v: string) { this._participantCode = v; } public get participantCode(): string { return this._participantCode;} private _participantCode: string;
    public set startCredit(v: number) { this._startCredit = v; } public get startCredit(): number { return this._startCredit;} private _startCredit: number;
    public set startDebt(v: number) { this._startDebt = v; } public get startDebt(): number { return this._startDebt;} private _startDebt: number;
    public set diffCredit(v: number) { this._diffCredit = v; } public get diffCredit(): number { return this._diffCredit;} private _diffCredit: number;
    public set diffDebt(v: number) { this._diffDebt = v; } public get diffDebt(): number { return this._diffDebt;} private _diffDebt: number;
    public set finalCredit(v: number) { this._finalCredit = v; } public get finalCredit(): number { return this._finalCredit;} private _finalCredit: number;
    public set finalDebt(v: number) { this._finalDebt = v; } public get finalDebt(): number { return this._finalDebt;} private _finalDebt: number;
    public set totalCredit(v: number) { this._totalCredit = v; } public get totalCredit(): number { return this._totalCredit;} private _totalCredit: number;
    public set totalDebt(v: number) { this._totalDebt = v; } public get totalDebt(): number { return this._totalDebt;} private _totalDebt: number;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
        
}

export class singleFilter extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:BalanceSheetViewModel) {
        super(parent);
        this.balanceSheet = parent;
        this.filters = ObservableArray.create<singleFilterItem>();
    }
    private balanceSheet:BalanceSheetViewModel;
    public set filters(v: ObservableArray<singleFilterItem>) { this._filters = v; } public get filters(): ObservableArray<singleFilterItem> { return this._filters;} private _filters: ObservableArray<singleFilterItem>;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    
    removeItem(filterItem:singleFilterItem) {
        this.filters.remove(filterItem);
    }
    remove(){
        this.balanceSheet.removeFilter(this);
    }
    DeleteFilter(){
        this.balanceSheet.DeleteFilter(this)
    }
}
export class singleFilterItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:singleFilter) {
        super(parent);
        this._owningFilter = parent;
    }
    private _owningFilter : singleFilter;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    remove(){
        this._owningFilter.removeItem(this);
    }
   
}

export class TurnOverViewModel extends ViewModel implements IPopup{
    public getTypeId(): string {return 'turnover';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.entries = ObservableArray.create<singleTransactionEntryViewModel>();
    }
    closePopup(resultCode: string=null) {}
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set entries(v: ObservableArray<singleTransactionEntryViewModel>) { this._entries = v; } public get entries(): ObservableArray<singleTransactionEntryViewModel> { return this._entries;} private _entries: ObservableArray<singleTransactionEntryViewModel>;
        
    async updateShowingTransactions(from:moment.Moment,until:moment.Moment,participants:any[])
    {
        try
        {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/AccountingServices/GetBalanceSheetRelatedTransactions',{
                From : from,
                Until:until,
                Participants:participants
            });
            this.entries.update(...result.Entries.map((x,i)=>{
                    let r = new singleTransactionEntryViewModel(this);
                    r.tableIndex = i+1;
                    r.accountCode = x.AccountCode;
                    r.accountName = x.AccountName;
                    r.amount = x.Amount;
                    r.districtId = x.DistrictId;
                    r.entryDescription = x.EntryDescription; 
                    r.entryId = x.EntryId;
                    r.index = x.Index;
                    r.transactionDescription = x.TransactionDescription;
                    r.transactionId = x.TransactionId;
                    r.transactionTime = moment.utc(x.TransactionTime);
                    r.crossReferenceCode = x.CrossReferenceCode;
                    r.transactionCode = x.TransactionCode;
                    return r;
                }));
        }
        catch (ex) 
        {
            console.log(ex);
        } 
        finally 
        {
            this.isLoading = false;
        }
    }
    handleMessage(message:ViewModelMessage){
        if(message instanceof selectedTransactionEntryMessage ){
            this.showTransaction(message.selectedTransactionEntry.transactionId)
        }else{
            return super.handleMessage(message);
        }
    }

    closeTransactionEntriesPopup(){
        this.closePopup();
    }

    showTransaction(id:string)
    {
        let detailVm = new TransactionDetailViewModel(this);
        detailVm.loadById(id);
        this.requestShowingPopup(detailVm);
    }
}




export class singleTransactionEntryViewModel extends ViewModel
{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel)
    {
        super(parent);
    }
    
    public set tableIndex(v: number) { this._tableIndex = v; } public get tableIndex(): number { return this._tableIndex;} private _tableIndex: number;
    public set debt(v: number) { this._debt = v; } public get debt(): number { return this._debt;} private _debt: number;
    public set credit(v: number) { this._credit = v; } public get credit(): number { return this._credit;} private _credit: number;
    public set accountCode(v: string) { this._accountCode = v; } public get accountCode(): string { return this._accountCode;} private _accountCode: string;
    public set accountName(v: string) { this._accountName = v; } public get accountName(): string { return this._accountName;} private _accountName: string;
    public set amount(v: number) { 
        this._amount = v;
        this.debt=0;
        this.credit=0;
        if(v<0){
            this.credit = -v;
        }else{
            this.debt = v;
        }
    } public get amount(): number { return this._amount;} private _amount: number;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set entryDescription(v: string) { this._entryDescription = v; } public get entryDescription(): string { return this._entryDescription;} private _entryDescription: string;
    public set entryId(v: string) { this._entryId = v; } public get entryId(): string { return this._entryId;} private _entryId: string;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set transactionDescription(v: string) { this._transactionDescription = v; } public get transactionDescription(): string { return this._transactionDescription;} private _transactionDescription: string;
    public set transactionId(v: string) { this._transactionId = v; } public get transactionId(): string { return this._transactionId;} private _transactionId: string;
    public set transactionTime(v: moment.Moment) { this._transactionTime = v; } public get transactionTime(): moment.Moment { return this._transactionTime;} private _transactionTime: moment.Moment;
    public set crossReferenceCode(v: string) { this._crossReferenceCode = v; } public get crossReferenceCode(): string { return this._crossReferenceCode;} private _crossReferenceCode: string;
    public set transactionCode(v: string) { this._transactionCode = v; } public get transactionCode(): string { return this._transactionCode;} private _transactionCode: string;

    loadRelatedTransaction()
    {
        this.handleMessage(new selectedTransactionEntryMessage(this));
    }
}

class selectedTransactionEntryMessage extends ViewModelMessage
{
    public selectedTransactionEntry:singleTransactionEntryViewModel;
    constructor(transactionEntry:singleTransactionEntryViewModel) {
        super();
        this.selectedTransactionEntry = transactionEntry;
    }
}

// export class transactionViewModel extends ViewModel implements IPopup{
//     public getTypeId(): string {return 'transaction';}
//     public GetDefaultView(): View<ViewModel> {return null;}
//     constructor(parent:ViewModel) {
//         super(parent);
//         this.transactionEntries = ObservableArray.create<singleTransactionEntryForTransactionViewModel>();
//         this.selectedDistinguishingDetailValues = ObservableArray.create<singleDistinguishingDetailValueForTransactionEntryViewModel>();
//     }
//     closePopup(resultCode: string=null) {
//     }
    
//     public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
//     public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
//     public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
//     public set description(v: string) { this._description = v; } public get description(): string { return this._description;} private _description: string;
//     public set crossReferenceCode(v: string) { this._crossReferenceCode = v; } public get crossReferenceCode(): string { return this._crossReferenceCode;} private _crossReferenceCode: string;
//     public set transactionCode(v: string) { this._transactionCode = v; } public get transactionCode(): string { return this._transactionCode;} private _transactionCode: string;
//     public set debt(v: number) { this._debt = v; } public get debt(): number { return this._debt;} private _debt: number;
//     public set credit(v: number) { this._credit = v; } public get credit(): number { return this._credit;} private _credit: number;
//     public set amount(v: number) { 
//         this._amount = v;
//         this.debt=0;
//         this.credit=0;
//         if(v<0){
//             this.credit = -v;
//         }else{
//             this.debt = v;
//         }
//     } public get amount(): number { return this._amount;} private _amount: number;
//     public set amountCurrencyId(v: string) { this._amountCurrencyId = v; } public get amountCurrencyId(): string { return this._amountCurrencyId;} private _amountCurrencyId: string;
//     public set amountCurrnecyName(v: string) { this._amountCurrnecyName = v; } public get amountCurrnecyName(): string { return this._amountCurrnecyName;} private _amountCurrnecyName: string;
//     public set transactionEntries(v: ObservableArray<singleTransactionEntryForTransactionViewModel>) { this._transactionEntries = v; } public get transactionEntries(): ObservableArray<singleTransactionEntryForTransactionViewModel> { return this._transactionEntries;} private _transactionEntries: ObservableArray<singleTransactionEntryForTransactionViewModel>;
//     public set selectedDistinguishingDetailValues(v: ObservableArray<singleDistinguishingDetailValueForTransactionEntryViewModel>) { this._selectedDistinguishingDetailValues = v; } public get selectedDistinguishingDetailValues(): ObservableArray<singleDistinguishingDetailValueForTransactionEntryViewModel> { return this._selectedDistinguishingDetailValues;} private _selectedDistinguishingDetailValues: ObservableArray<singleDistinguishingDetailValueForTransactionEntryViewModel>;
//     public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
//     async load(id:string){
//         try {
//             this.isLoading = true;
//             let result = await ServerConnection.callServer('/Complex/AccountingServices/LoadTransaction',{
//                 Id:id,
//             });
//             let transaction = result.Transaction;
//             this.id = transaction.Id;
//             this.name = transaction.Name; 
//             this.time = transaction.Time;
//             this.description = transaction.Description;
//             this.crossReferenceCode = transaction.CrossReferenceCode;
//             this.transactionCode = transaction.TransactionCode;
//             this.amount = transaction.Amount;
//             this.amountCurrencyId = transaction.AmountCurrencyId;
//             this.amountCurrnecyName = transaction.AmountCurrencyName;
//             this.transactionEntries.update(...transaction.Entries.map(y => {
//                 let q = new singleTransactionEntryForTransactionViewModel(this);
//                 q.description = y.Description;
//                 q.amount = y.Amount;
//                 q.currencyId = y.CurrencyId
//                 q.currencyName = y.CurrencyName
//                 q.order = y.Order,
//                 q.accountId = y.Account[y.Account.length - 1].AccountId;
//                 q.accountName = y.Account[y.Account.length - 1].AccountName;
//                 q.accountCode = y.Account[y.Account.length - 1].AccountCode;
//                 q.distinguishingDetailValues.update(...y.DetailValues.map(z => {
//                     let p = new singleDistinguishingDetailValueForTransactionEntryViewModel(q);
//                     p.order = z.Order;
//                     p.accountDetailId = z.AccountDetailId;
//                     p.detailValueId = z.DetailValueId;
//                     p.accountDetailName = z.AccountDetailName;
//                     p.detailValueName = z.DetailValueName;
//                     return p;
//                 }));
//                 return q;
//             }));
//             this.transactionEntries.sort((a, b) =>  a.order - b.order);
//         } catch (ex) {
//             console.log(ex);
//         } finally {
//             this.isLoading = false;
//         }
//     }
    
//     handleMessage(message:ViewModelMessage)
//     {
//         if(message instanceof selectedTransactionEntryForDetailValuesLoadingMessage)
//         {
//             this.loadDetailValues(message.selectedEntry);
//         }
//         else
//         {
//             return super.handleMessage(message);
//         }
//     }

//     loadDetailValues(entry: singleTransactionEntryForTransactionViewModel)
//     {
//         entry.distinguishingDetailValues.sort((a, b) =>  a.order - b.order);
//         this.selectedDistinguishingDetailValues.update(...entry.distinguishingDetailValues.map(z => {
//             let p = new singleDistinguishingDetailValueForTransactionEntryViewModel(this);
//             p.order = z.order;
//             p.accountDetailId = z.accountDetailId;
//             p.detailValueId = z.detailValueId;
//             p.accountDetailName = z.accountDetailName;
//             p.detailValueName = z.detailValueName;
//             return p;
//         }));
//     }
//     closeSelectedTransactionPopup(){
//         this.closePopup();
//     }
// }

// export class singleTransactionEntryForTransactionViewModel extends ViewModel{
//     public getTypeId(): string {return '';}
//     public GetDefaultView(): View<ViewModel> {return null;}
//     constructor(parent:ViewModel) 
//     {
//         super(parent);
//         this.distinguishingDetailValues = ObservableArray.create<singleDistinguishingDetailValueForTransactionEntryViewModel>();
//     }
    
//     public set description(v: string) { this._description = v; } public get description(): string { return this._description;} private _description: string;
//     public set currencyId(v: string) { this._currencyId = v; } public get currencyId(): string { return this._currencyId;} private _currencyId: string;
//     public set currencyName(v: string) { this._currencyName = v; } public get currencyName(): string { return this._currencyName;} private _currencyName: string;
//     public set order(v: number) { this._order = v; } public get order(): number { return this._order;} private _order: number;    
//     public set accountId(v: string) { this._accountId = v; } public get accountId(): string { return this._accountId;} private _accountId: string;
//     public set accountName(v: string) { this._accountName = v; } public get accountName(): string { return this._accountName;} private _accountName: string;
//     public set accountCode(v: string) { this._accountCode = v; } public get accountCode(): string { return this._accountCode;} private _accountCode: string;
//     public set distinguishingDetailValues(v: ObservableArray<singleDistinguishingDetailValueForTransactionEntryViewModel>) { this._distinguishingDetailValues = v; } public get distinguishingDetailValues(): ObservableArray<singleDistinguishingDetailValueForTransactionEntryViewModel> { return this._distinguishingDetailValues;} private _distinguishingDetailValues: ObservableArray<singleDistinguishingDetailValueForTransactionEntryViewModel>;
//     public set debt(v: number) { this._debt = v; } public get debt(): number { return this._debt;} private _debt: number;
//     public set credit(v: number) { this._credit = v; } public get credit(): number { return this._credit;} private _credit: number;
//     public set amount(v: number) { 
//         this._amount = v;
//         this.debt=0;
//         this.credit=0;
//         if(v<0){
//             this.credit = -v;
//         }else{
//             this.debt = v;
//         }
//     } public get amount(): number { return this._amount;} private _amount: number;
    
//     loadDetailValues()
//     {
//         this.handleMessage(new selectedTransactionEntryForDetailValuesLoadingMessage(this));
//     }
// }

// class selectedTransactionEntryForDetailValuesLoadingMessage extends ViewModelMessage
// {
//     public selectedEntry:singleTransactionEntryForTransactionViewModel;
//     constructor(selectedEntry:singleTransactionEntryForTransactionViewModel) 
//     {
//         super();
//         this.selectedEntry = selectedEntry;
//     }
// }

// export class singleDistinguishingDetailValueForTransactionEntryViewModel extends ViewModel{
//     public getTypeId(): string {return '';}
//     public GetDefaultView(): View<ViewModel> {return null;}
//     constructor(parent:ViewModel) 
//     {
//         super(parent);
//     }

//     public set order(v: number) { this._order = v; } public get order(): number { return this._order;} private _order: number;
//     public set accountDetailId(v: string) { this._accountDetailId = v; } public get accountDetailId(): string { return this._accountDetailId;} private _accountDetailId: string;
//     public set detailValueId(v: string) { this._detailValueId = v; } public get detailValueId(): string { return this._detailValueId;} private _detailValueId: string;
//     public set accountDetailName(v: string) { this._accountDetailName = v; } public get accountDetailName(): string { return this._accountDetailName;} private _accountDetailName: string;
//     public set detailValueName(v: string) { this._detailValueName = v; } public get detailValueName(): string { return this._detailValueName;} private _detailValueName: string;
// }
